import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchClaimDocumentSuccessAction,
    fetchClaimDocumentWithQueryParamsSuccessAction,
} from '../actions/claimDocument';

type State = {
    claimDocument:
        | {
              byId: { [id: string]: any };
              allIds: Array<string> | [];
          }
        | any;
    pagination: {
        page: number;
        limit: number;
        totalPages: number;
        count: number;
        totalCount: number;
    } | null;
    loading: boolean;
};
const INITIAL_STATE: State = {
    claimDocument: {
        byId: {},
        allIds: [],
    },
    pagination: null,
    loading: true,
};

const fetchClaimDocument = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchClaimDocumentSuccess = (
    state: State,
    action: PayloadAction<fetchClaimDocumentSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );
    return {
        ...state,
        loading: false,
        claimDocument: {
            byId,
            allIds,
        },
    };
};

const fetchClaimDocumentFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const fetchClaimDocumentWithQueryParams = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchClaimDocumentWithQueryParamsSuccess = (
    state: State,
    action: PayloadAction<fetchClaimDocumentWithQueryParamsSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );
    return {
        ...state,
        loading: false,
        claimDocument: {
            byId,
            allIds,
        },
        pagination: {
            page: action.payload.body.page,
            limit: action.payload.body.limit,
            totalPages: action.payload.body.totalPages,
            count: action.payload.body.count,
            totalCount: action.payload.body.totalCount,
        },
    };
};

const fetchClaimDocumentWithQueryParamsFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const claimDocument = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_CLAIM_DOCUMENT]: fetchClaimDocument,
    [ActionTypes.FETCH_CLAIM_DOCUMENT_SUCCESS]: fetchClaimDocumentSuccess,
    [ActionTypes.FETCH_CLAIM_DOCUMENT_FAILED]: fetchClaimDocumentFailed,
    [ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS]:
        fetchClaimDocumentWithQueryParams,
    [ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_SUCCESS]:
        fetchClaimDocumentWithQueryParamsSuccess,
    [ActionTypes.FETCH_DOCUMENT_TYPES_WITH_QUERY_PARAMS_FAILED]:
        fetchClaimDocumentWithQueryParamsFailed,
});

export default claimDocument;
